import Vue from 'vue'
import Router from 'vue-router'
import Firebase from 'firebase'
import Meta from'vue-meta'

import { fb } from "../components/firebaseconfig";
let db = fb.database();


const Home = () => import('@/components/home')
// const HomeBeta = () => import('@/components/homebeta')
const SlinkView = () => import('@/components/slinkview')
// const SlinkLiveView = () => import('@/components/slinkliveview')
const Admin = () => import('@/components/admin')
// const AdminDev = () => import('@/components/admindev')
const EnterpriseAdmin = () => import('@/components/enterpriseadmin')
const SuperAdmin = () => import('@/components/superadmin')
const SuperAdminDev = () => import('@/components/superadmindev')
const SuperAdminLinks = () => import('@/components/saLinks')
const SuperAdminAdverts = () => import('@/components/saAdverts')
const SuperAdminTools = () => import('@/components/saTools')
const gos = () => import('@/components/gos')
const wyr= () => import('@/components/wyr')
// const bos = () => import('@/components/bos')
// const Gallery = () => import('@/components/gallery')
// const Billing = () => import('@/components/billing')
// const Card = () => import('@/components/card')
// const Rewards = () => import('@/components/coins')
// const MyFSP = () => import('@/components/myfsp')
const NotFound = () => import('@/components/404')
const TicketValidator = () => import('@/components/ticketValidator')
const ScratchCardChecker = () => import('@/components/scratchcardChecker')
const AdminTools = () => import('@/components/AdminTools')
const WyrAdminStats = () => import('@/components/WyrAdminStats')
const AdminAccounts = () => import('@/components/AdminAccounts')
const Under18Page = () => import('@/components/Under18Page')


Vue.use(Router)
Vue.use(Meta)

// export default new Router({
  let router = new Router({
	mode: 'history',
  watch: {
    $route(to) {
      //  document.title = `APPLICATION_NAME - ${to.meta.title}`;
       const link = document.querySelector("[rel='icon']")
       link.setAttribute('href',to.meta.icon)
    }
  },
  routes: [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/girlsofslink/:url?',
    name: 'Girls of Slink',
    component: gos,
    meta: {
        requiresAuth: false,
        // title: "Girls of Slink",
    },
    alias: ['/gos', '/girlsofslink', '/bos', '/boysofslink']
  },
  {
    path: '/wouldyourather/:url?',
    name: 'Would You Rather?',
    component: wyr,
    meta: {
        requiresAuth: false,
        // title: "Girls of Slink",
    },
    alias: ['/wyr']
  },
  {
    path: '/wouldyourather/:url?/:uid?',
    name: 'Would You Rather?',
    component: wyr,
    meta: {
        requiresAuth: false,
        // title: "Girls of Slink",
    },
    alias: ['/wyr']
  },
  {
    path: '/wouldyourather/:url?/player/:playerUrl',
    name: 'Would You Rather Player',
    component: wyr,
    meta: {
        requiresAuth: false,
    }
  },
  {
    path: '/justjeet',
    redirect: { name: 'Would You Rather?', params: { url: 'justjeet' } }
  },
  // {
  //   path: '/boysofslink/:url?',
  //   name: 'Boys of Slink',
  //   component: bos,
  //   meta: {
  //       requiresAuth: false,
  //       // title: "Girls of Slink",
  //   },
  //   alias: ['/bos', '/boysofslink']
  // },
  {
    path: '/affiliate/:affiliatecode',
    name: 'SlinkViewAffiliate',
    component: Home,
    props: true
  },
  // {
  //   path: '/homebeta',
  //   name: 'Home Beta',
  //   component: HomeBeta
  // },
  {
    path: '/notfound',
    name: 'Page Not Found',
    component: NotFound,
    meta: {
        requiresAuth: false
    }
  },
  {
    path: '/underage',
    name: 'Under 18 Page',
    component: Under18Page,
    meta: {
        requiresAuth: false
    }
  },
  {
    path: '/ticketvalidator',
    name: 'Ticket Validator',
    component: TicketValidator,
    meta: {
        requiresAuth: false
    }
  },
  {
    path: '/scratchcardvalidator',
    name: 'Scratchcard Validator',
    component: TicketValidator,
    meta: {
        requiresAuth: false
    }
  },
  {
    path: '/scratchcardchecker',
    name: 'Scratchcard Checker',
    component: ScratchCardChecker,
    meta: {
        requiresAuth: false
    }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: {
        requiresAuth: true
    }
  },
  // {
  //   path: '/admin/rewards',
  //   name: 'Rewards',
  //   component: Rewards,
  //   meta: {
  //       requiresAuth: true
  //   },
  //   props: true
  // },
  // {
  //   path: '/admin/myfsp',
  //   name: 'Featured Slink Pages',
  //   component: MyFSP,
  //   meta: {
  //       requiresAuth: true
  //   },
  //   props: true
  // },
  // {
  //   path: '/admin/:uid',
  //   name: 'Admin',
  //   component: Admin,
  //   meta: {
  //       requiresAuth: true
  //   }
  // },
  // {
  //   path: '/admindev',
  //   name: 'AdminDev',
  //   component: AdminDev,
  //   meta: {
  //       requiresAuth: true
  //   }
  // },
  {
    path: '/enterprise',
    name: 'Enterprise Admin',
    component: EnterpriseAdmin,
    meta: {
        requiresAuth: true
    }
  },
  {
    path: '/superadmin',
    name: 'Super Admin',
    component: SuperAdmin,
    meta: {
        requiresAuth: true
    }
  },
  {
    path: '/superadmindev',
    name: 'Super Admin Dev',
    component: SuperAdminDev,
    meta: {
        requiresAuth: true
    }
  },
  {
    path: '/superadmin/links',
    name: 'Super Admin Links',
    component: SuperAdminLinks,
    meta: {
        requiresAuth: true
    }
  },
  {
    path: '/superadmin/adverts',
    name: 'Super Admin Adverts',
    component: SuperAdminAdverts,
    meta: {
        requiresAuth: true
    }
  },
  {
    path: '/superadmin/tools',
    name: 'Super Admin Tools',
    component: SuperAdminTools,
    meta: {
        requiresAuth: true
    }
  },
  {
    path: '/superadmin/accounts',
    name: 'Admin Accounts',
    component: AdminAccounts,
    meta: {
        requiresAuth: true
    }
  },
  {
    path: '/admin/tools/:secret',
    name: 'Admin Tools',
    component: AdminTools,
    meta: {
        requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      // Basic protection - replace with proper authentication
      if (to.params.secret === 'update_wyr_urls') {
        next();
      } else {
        next('/admin');
      }
    }
  },
  {
    path: '/admin/wyr-stats/:secret',
    name: 'WYR Admin Stats',
    component: WyrAdminStats,
    meta: {
        requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      // Basic protection - replace with proper authentication
      if (to.params.secret === 'stats_dashboard') {
        next();
      } else {
        next('/admin');
      }
    }
  },
  // {
  //   path: '/gallery/:filter',
  //   name: 'Gallery',
  //   component: Gallery,
  //   props: true
  // }, 
  // {
  //   path: '/coins',
  //   name: 'Coins',
  //   component: Coins,
  //   meta: {
  //     requiresAuth: true
  //   },
  //   props: true
  // }, 
  // {
  //   path: '/billing/:state?',
  //   name: 'Billing',
  //   component: Billing,
  //   meta: {
  //     requiresAuth: true
  //   },
  //   props: true
  // }, 
  // {
  //   path: '/card/:state?',
  //   name: 'Card-Shop',
  //   component: Card,
  //   meta: {
  //     requiresAuth: true
  //   },
  //   props: true
  // }, 
  // {
  //   path: '/c/:uid',
  //   name: 'Card',
  // },
  // {
  //   path: '/:uid/photo',
    
  //   beforeEnter: (to, from) => {
  //     console.log('photo', document.referrer)
  //     // location.href = 'https://us-central1-slink-64a53.cloudfunctions.net/profilephoto/' + to.params.uid
  //     window.location.replace('https://us-central1-slink-64a53.cloudfunctions.net/profilephoto/' + to.params.uid)
  //   }
    
  // },
  {
    path: '/:uid/ticket/:ticket',
    name: 'SlinkViewTicket',
    component: SlinkView,
    props: true
  },

  // {
  //   // LIVE SLINKVIEW
  //   path: '/live/:uid/:hop?',
  //   name: 'SlinkLiveView',
  //   component: SlinkView,
  //   meta:{
  //     // 'icon':"https://us-central1-slink-64a53.cloudfunctions.net/profilePicture/goubtube"
  //   }, 
  //   props: true
  // },
  {
    // GENERAL SLINKVIEW
    path: '/:uid/location/:loc',
    name: 'CineMapper Location',
    component: SlinkView,
    meta:{
    }, 
    props: true
  },
  {
    // GENERAL SLINKVIEW
    path: '/:uid/category/:cat',
    name: 'CineMapper Category',
    component: SlinkView,
    meta:{
    }, 
    props: true
  },
  // {
  //   // GENERAL SLINKVIEW
  //   path: '/:uid/search/:search',
  //   name: 'CineMapper Search',
  //   component: SlinkView,
  //   meta:{
  //   }, 
  //   props: true
  // },
  // {
  //   // GENERAL SLINKVIEW
  //   path: '/:uid/admin',
  //   name: 'SlinkView',
  //   component: SlinkView,
  //   meta:{
  //   }, 
  //   props: true
  // },
  
  {
    // GENERAL SLINKVIEW
    path: '/:uid/:hop?',
    name: 'SlinkView',
    component: SlinkView,
    meta:{
      // 'icon':"https://us-central1-slink-64a53.cloudfunctions.net/profilePicture/goubtube"
    }, 
    props: true
  },
  {
    // GENERAL SLINKVIEW
    path: '/:uid/player/:user',
    name: 'Scratch and Win SlinkView',
    component: SlinkView,
    meta:{
    }, 
    props: true
  },
  
  ],
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  // console.log('router', from, to)
  // if(to.name == 'Card'){

    
    // db.ref('cards/'+ to.params.uid).once('value').then(function(snapshot) {
    //   if(snapshot.val()){
    //     db.ref('users/'+ snapshot.val().uid).once('value').then(function(urlSnapshot) {
    //       next({
    //         name: 'SlinkView',
    //         params: {
    //           uid: urlSnapshot.val().url,
    //           card: true,
    //         }
    //       })
    //     });
    //   }
    //   else{
    //     next({
    //       name: 'Home',
    //     })
    //   }
    // });

      
    //   db.ref('url').orderByChild('card').equalTo(to.params.uid).limitToFirst(1).once('value').then(snapshot => {
    //   // console.log('query run' )
    //   const user = snapshot.val()
    //   if(user != null){
    //     for(var i in user){
    //       console.log()
    //         // next({
    //         //   name: 'SlinkView',
    //         //   params: {
    //         //     uid: user[i].url,
    //         //     card: true
    //         //   }
    //         // })
    //     }
    //   }
    //   else{
    //     next({
    //       name: 'Home',
    //     })
    //   }
    // })
  // }
  if(to.name == 'Home'){
    // else if(to.name == 'Home'){
    Firebase.auth().onAuthStateChanged((user) => {
      if(user)next({name:'Admin'})
    })
  }
  else{
    // console.log('router to', to)
  }
  if(to.params.uid === 'cinemapper'){
    document.title = "CineMapper"
    const favicon = document.getElementById("shortcut icon");
    favicon.href = "https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/userContent%2F-NaBwc3brLvzF2VsHzIm%2Fmarkers%2Fdefault.png?alt=media&token=fcb2d86a-3470-447a-9a47-1bdfdb187985";
  }
  if(to.name === 'Girls of Slink'){
    document.title = "Girls of Slink"
    // const favicon = document.getElementById("shortcut icon");
    // favicon.href = "https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/userContent%2F-NaBwc3brLvzF2VsHzIm%2Fmarkers%2Fdefault.png?alt=media&token=fcb2d86a-3470-447a-9a47-1bdfdb187985";
  }
  if(to.name === 'Would You Rather?'){
    document.title = "Would You Rather by Slink"
  }
  // else if(to.name == 'SlinkView'){
    // console.log('going to slinkview')
    // const favicon = document.getElementById("shortcut icon");
    // console.log('favicon', favicon)
    // favicon.href = "https://us-central1-slink-64a53.cloudfunctions.net/profilePicture/"+to.params.uid;
  // }
  Firebase.auth().onAuthStateChanged((user) => {
    let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    if (requiresAuth && !user) next({name:'Home'})
    else next()
  })
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js